export function isValidIndianPhoneNumber(phoneNumber) {
  if (!phoneNumber) return false;

  const cleanedPhoneNumber = String(phoneNumber).replace(/\D/g, "");

  const normalizedPhoneNumber =
    cleanedPhoneNumber.length === 12 && cleanedPhoneNumber.startsWith("91")
      ? cleanedPhoneNumber.slice(2)
      : cleanedPhoneNumber.length === 11 && cleanedPhoneNumber.startsWith("0")
        ? cleanedPhoneNumber.slice(1)
        : cleanedPhoneNumber;

  return /^[6-9]\d{9}$/.test(normalizedPhoneNumber);
}
